import { connect } from 'react-redux';
import {
  FiltersMortgageButtons,
  IFiltersMortgageButtonsProps,
} from '../../components/FiltersMortgageButtons';
import { IReduxState } from '../../types/redux';
import { buildMortgageHref } from './MortgageHrefGenerator';

export const mapStateToProps = (state: IReduxState): IFiltersMortgageButtonsProps => {
  return {
    rightButtonTitle: 'Рассчитать',
    rightButtonHref: buildMortgageHref(state),
  };
};

export const FiltersMortgageButtonsContainer = connect(mapStateToProps)(FiltersMortgageButtons);
